export { default } from './components/Title';
